// Filters a browse page (/tests, /glossary) as the reader types, and optionally to
// ready items only. Hides groups (and their sidebar links) that end up empty, and an
// item's own sidebar link (data-item-link="<item id>") when it is filtered out.
export default function initTestFilter() {
	const root = document.querySelector("[data-test-filter-root]");
	if (!root) return;
	const input = root.querySelector("[data-test-filter]");
	const readyOnly = root.querySelector("[data-test-filter-ready]");
	const empty = root.querySelector("[data-test-filter-empty]");
	const questions = root.querySelector("[data-test-question-block]");

	const apply = () => {
		const words = input.value.toLowerCase().trim().split(/\s+/).filter(Boolean);
		const onlyReady = readyOnly?.checked;
		let shown = 0;
		root.querySelectorAll("[data-test-family]").forEach((family) => {
			let visible = 0;
			family.querySelectorAll("[data-test-item]").forEach((item) => {
				const match = words.every((w) => item.dataset.search.includes(w)) && (!onlyReady || item.dataset.ready === "true");
				item.hidden = !match;
				const itemLink = item.id && root.querySelector(`[data-item-link="${item.id}"]`);
				if (itemLink) itemLink.hidden = !match;
				if (match) visible++;
			});
			family.hidden = visible === 0;
			const link = root.querySelector(`[data-family-link="${family.id}"]`);
			if (link) link.hidden = visible === 0;
			shown += visible;
		});
		if (questions) questions.hidden = words.length > 0;
		empty.hidden = shown > 0;
	};

	input.addEventListener("input", apply);
	readyOnly?.addEventListener("change", apply);
}
